import styled from 'styled-components';

export const TabBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding: 11px 0;
`;

export const Tab = styled.button<{ selected: boolean }>`
  align-items: center;
  background: ${({ selected }) =>
    selected ? 'var(--grey-300)' : 'transparent'};
  border: none;
  border-radius: 4px;
  box-shadow: ${({ selected }) => (selected ? 'var(--shadow-sm)' : 'none')};
  color: ${({ selected }) => (selected ? 'var(--black)' : 'var(--grey-700)')};
  cursor: pointer;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 0.3rem 0.5rem;
  transition: all 0.2s ease;

  svg {
    color: inherit;
    transition: color 0.2s ease;
  }

  &:hover {
    background: var(--grey-300);
    box-shadow: var(--shadow-sm);
    color: var(--black);

    svg {
      color: var(--black);
    }
  }
`;
